import { LaiSuatText } from "constants/choVayConst";
import React, { useEffect, useState } from "react";
import { catChuoi } from "utils/stringExtension";
import { useSelector, useDispatch } from "react-redux";
import { nFormatter } from "utils/currencyFormat";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachhang } from "./ChiTietKhachHang/BtnChiTietKhachhang";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { BtnKhoiPhuc } from "./ChucNang/KhoiPhuc/BtnKhoiPhuc";

export const ContentTable = ({ listHopDongDeleteFull, quyenXoa, quyenKhoiPhuc }) => {
  const dataSearch = useSelector((state) => state.dataSearchHopDongDelete);
  return listHopDongDeleteFull.list.map((item, index) => (
    <div className="custom-table-row" key={item.ChoVayId || "row" + index}>
      <div className="custom-table-cell username-cell flex-basis-8 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">
            {index + 1 + (dataSearch.pageIndex - 1) * 20}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-17 flex-basis-12-8-sm">
        <span className="mobile-column-name">Tên khách hàng</span>
        <div className="center-wrapper">
          <p>
            <BtnChiTietKhachhang item={item} />
            <br />
            {item.phoneCus && (
              <span title={item.phoneCus}> {catChuoi(item.phoneCus, 10)}</span>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-15-6-sm">
        <span className="mobile-column-name">Mã cho vay</span>
        <div className="center-wrapper">
          <p className="text-center">
            <BtnChiTietHopDong item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-17 flex-basis-17-8-sm">
        <span className="mobile-column-name">Số tiền vay</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span className="color-do-bold">{formatNumber(item.Sotienvay)}</span>{" "}
            <br />
            {item.Type !== 2 && (
              <span className="font-lai color7">
                (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
              </span>
            )}
            {item.Type === 2 && (
              <span className="font-lai color7">
                (
                {item.StatusPaidHo === 1
                  ? "Lãi thiếu: " +
                    nFormatter(item.ValueLai * item.CountTypePaid)
                  : "Lãi đủ: " + nFormatter(item.ValueLai * item.BocTrongVong)}
                )
              </span>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-9-2-sm">
        <span className="mobile-column-name">Ngày vay</span>
        <div className="center-wrapper">
          <p className="text-center color7">{getDate(item.NgayVay)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-15-sm">
        <span className="mobile-column-name">Người xoá</span>
        <div className="center-wrapper">
          <p className="text-left color7 word-break">{item.UpdatedUser}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-13 flex-basis-15-sm">
        <span className="mobile-column-name">Ngày xoá</span>
        <div className="center-wrapper">
          <p className="text-center color7">
            {getDate(item.UpdatedTime)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-8-6-sm  action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {quyenKhoiPhuc && item.ChoVayId && (
              <BtnKhoiPhuc id={item.ChoVayId} code={item.Code} />
            )}
            {quyenXoa && <BtnXoa id={item.ChoVayId} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
